import { IntegrationContainerImageScannerBaseDataProvider } from './IntegrationContainerImageScannerBaseDataProvider';
import { IntegrationContainerImageScannerWebComponentSchema } from '../types';

export class IntegrationContainerImageScannerNirvanaDataProvider extends IntegrationContainerImageScannerBaseDataProvider {
  async getDataForView(): Promise<IntegrationContainerImageScannerWebComponentSchema> {
    return {} as unknown as IntegrationContainerImageScannerWebComponentSchema;
  }
}
